import React from "react"

const Input = props => {
  const { searchButton, className, id, type, ...restProps } = props
  return (
    <>
      <input
        type={type}
        name={id}
        id={id}
        className={`${
          className ? className : ""
        } tw-shadow-sm tw-border-solid focus:tw-outline-none focus:tw-border-green-500 tw-py-2 tw-px-4 tw-block tw-w-full sm:tw-text-sm tw-border-2 tw-border-gray-300 tw-rounded-md`}
        {...restProps}
      />
      {searchButton && (
        <button
          className="btn btn-primary hasTooltip tw-ml-4 finder"
          type="submit"
          title=""
          data-original-title="Go"
        >
          <i className="icon-search icon-white"></i>
        </button>
      )}
    </>
  )
}

export default Input
